module.exports = __webpack_public_path__ + "media/images/mail-header-c08f3fc57fe4a7e10dd01179ccdc7257.png";